import component from './paycell-info-link.component';

export default angular
  .module('fizyweb.paycell.infolink', [])
  .component('fizyPaycellInfoLink', component).name;



// WEBPACK FOOTER //
// src/app/components/paycell-info-link/paycell-info-link.module.ts